import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Subscription } from 'rxjs'
import { TrackProspectsService } from '../../services/track.prospects.service'
import { ProspectModel } from '../../models/track/prospect.model'
import { MatTableDataSource, PageEvent } from '@angular/material'
import { fuseAnimations } from '../../../core/animations'
import { ActivatedRoute } from '@angular/router'
import { locale } from './i18n/nl'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'

// @ts-ignore
@Component({
  selector: 'app-prospects',
  templateUrl: './prospects.component.html',
  styleUrls: ['./prospects.component.scss'],
  animations: fuseAnimations,
})
export class ProspectsComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  onProspectsChanged: Subscription
  onSearchChanged: Subscription
  prospects: ProspectModel[]

  displayedColumns = ['id', 'first_name', 'last_name', 'company_name', 'status', 'iban', 'created_at', 'action']
  dataSource: any
  limit = 20
  currentPage = 0
  total: number
  totalPages: number

  constructor(
    private _trackProspectService: TrackProspectsService,
    private _route: ActivatedRoute,
    private _translationLoader: FuseTranslationLoaderService,
  ) {
    this._translationLoader.loadTranslations(locale)
    this.searchInput = new FormControl()
    this.dataSource = new MatTableDataSource([])
  }

  ngOnInit() {
    this.onProspectsChanged = this._trackProspectService.prospectsChanged.subscribe(prospects => {
      this.prospects = prospects.items
      this.total = prospects.total
      this.currentPage = prospects.currentPage - 1
      this.limit = prospects.limit
      this.totalPages = prospects.totalPages
      this.dataSource = new MatTableDataSource<ProspectModel>(this.prospects)
    })

    this.onSearchChanged = this.searchInput.valueChanges
      .debounceTime(1000)
      .distinctUntilChanged()
      .do(searchText => {
        this._trackProspectService.changeSearch(searchText)
      })
      .subscribe()
  }

  ngOnDestroy(): void {
    this.onProspectsChanged.unsubscribe()
    this.onSearchChanged.unsubscribe()
  }

  getServerData(event?: PageEvent) {
    this._trackProspectService.changeFilter(event)
  }

  acceptProspect(prospect: ProspectModel) {
    // this._trackProspectService.accept(prospect);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/prospects/prospects.component.ts